import styled from 'styled-components';

export const StyledBasicDetailsSection = styled.section`
   display: flex;
   flex-direction: column;
   gap: 24px;
   width: 500px;
`;

StyledBasicDetailsSection.displayName = 'StyledBasicDetailsSection';
